/**
 * perf 2026-08-18: sekcja ponizej pierwszego ekranu renderuje sie jako pusty
 * kontener, a tresc dociaga sie z Section Rendering API dopiero, gdy uzytkownik
 * do niej dojezdza. Cztery sekcje featured-collection na stronie glownej to
 * zmierzone 239 ms czasu renderu Shopify i 526 kB HTML.
 *
 * Korzysta z window.initLazyScript z main.js - tego samego mechanizmu, ktorego
 * uzywa product-recommendations.js.
 */
if (!customElements.get('lazy-section')) {
  class LazySection extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.init.bind(this), 800);
    }

    async init() {
      const { url } = this.dataset;
      if (!url) return;

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        const section = tmpl.content.querySelector('[id^="shopify-section"]');
        if (!section || !section.hasChildNodes()) return;

        // Podmiana zamiast wypelnienia: znika placeholder razem z min-height,
        // wiec sekcja ma dokladnie taka wysokosc, jaka ma jej tresc.
        this.replaceWith(...section.childNodes);
      } catch (error) {
        // Zostaje pusty kontener - lepsze niz polowa sekcji.
        console.log(error); // eslint-disable-line
      }
    }
  }

  customElements.define('lazy-section', LazySection);
}
